import React from 'react';
import { FormProps, Modal, ModalBody, ModalHeader } from 'react-bootstrap';
import { Beneficiary } from '../../types';
import AddEditBeneficiaryForm from './AddEditBeneficiaryForm';
import AddEditBeneficiaryQAForm from './AddEditBeneficiaryQAForm';

export type AddEditBeneficiaryModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  isForFamilyMember?: boolean;
  title: string;
  subtitle?: string;
  existingBeneficiary?: Beneficiary;
  handleClose: () => void;
  handleSubmit: (formData: any) => void;
  formProps?: FormProps;
}>;

const AddEditBeneficiaryModal = ({
  showModal = false,
  isForFamilyMember = false,
  existingBeneficiary,
  handleClose,
  handleSubmit,
  title,
  subtitle,
  formProps,
  ...props
}: AddEditBeneficiaryModalProps) => {
  const [data, setData] = React.useState<any>();
  return (
    <Modal
      dialogClassName='modal-lg-top'
      show={showModal}
      onHide={() => {
        setData(null);
        handleClose();
      }}
      size="xl"
      {...props}
    >
      <ModalHeader className='no-border' closeButton>
        <h4 className="text-truncate">{title}</h4>
      </ModalHeader>
      <ModalBody>
        {subtitle && <h6 className={'mb-10 text-sm-16-lg-20'}>
          {subtitle}
        </h6>}
        {!data && <AddEditBeneficiaryForm
          isForFamilyMember={isForFamilyMember}
          existingBeneficiary={existingBeneficiary}
          handleClose={handleClose}
          handleOnSubmit={(formData) => {
            if (formData.beneficiaryType === 'person') {
              setData(formData);
            } else {
              handleSubmit(formData);
            }
          }}
          {...formProps}
        />}
        {data && <AddEditBeneficiaryQAForm
          formData={data}
          isForFamilyMember={isForFamilyMember}
          handleClose={() => {
            setData(null);
            handleClose();
          }}
          handleOnSubmit={(formData) => {
            setData(null);
            handleSubmit(formData);
          }}
          {...formProps}
        />}
      </ModalBody>
    </Modal>
  );
};

export default AddEditBeneficiaryModal;
